<template>
  <router-link :to="'/menu/' + category.id">
    <div
      class="relative rounded-lg shadow-lg overflow-hidden transition m-1 block"
      @touchstart="toggleAnimation($event)"
      @touchend="toggleAnimation($event)"
    >
      <img :src="category.imgUrl" alt="" class="h-36" />
      <div
        class="absolute w-full h-full bg-gray-800/70 flex items-center justify-center top-0"
      >
        <span class="text-lg text-white text-center font-bold">{{
          category.menu_Name
        }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "CategoryCard",
  props: ["category"],
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle("scale-95");
      event.currentTarget.classList.toggle("shadow");
    },
  },
};
</script>

